$(document).ready(function() {

  /* VARIABLES
  -----------------------------------------------------*/

  var subNavTrigger       = $('li.hasSubNav'),
      subNav              = $('.subNav'),
      featuredProduct     = $('.product-container'),
      shoppingBag         = $('#shopping-bag'),
      shoppingBagMobile   = $('#shopping-bag-mobile'),

      searchBoxMobile   = $('#search-icon-mobile'),
      searchBoxSlider   = $('#search-slider'),
      searchBoxClose	= $('#search-close'),

      shoppingBagSlider   = $('#shopping-bag-slider'),
      addToCart           = $('#addtocart'),
      baggedProduct       = $('.bagged-product'),
      closeShoppingBag    = $('#close'),
      cartSelector		  = $('.cartSelector'),
      wrap                = $('.wrap');
  
    
  /* FLY-OUT SHOPPING CART
  -----------------------------------------------------*/

  shoppingBag.click(function() {
   openShoppingCart();
  });
    
  shoppingBagMobile.click(function() {
   openShoppingCart();
  });
  
  closeShoppingBag.click(function() {
   closeShoppingCart(); 
  });
  
  searchBoxMobile.click(function() {
   openSearchBox();
  });
  
  searchBoxClose.click(function() {
   closeSearchBox(); 
  });
    
  $('.shoppingBagIsOpen').click(function() {
    closeShoppingCart();   
  });
  
  cartSelector.click(function() {
   openShoppingCart();
  });
  
  /* SLIDER
  -----------------------------------------------------*/
 
    $('#skin-slider').responsiveSlides({
      pager:true,
      pause:true,
      manualControls: ".slider-pager",
    });	
  
    $('.slider-img-container').imgLiquid();
    
  /* FEATURED PRODUCTS
  -----------------------------------------------------*/

  featuredProduct.hover(
    function() {
      $(this).find('.overlay').fadeIn('normal');
    },
    function() {
      $(this).find('.overlay').hide();
    }
  );

  /* SUB-NAVIGATION 
  -----------------------------------------------------*/
  
  subNavTrigger.hoverIntent({
    over: navDown, 
    out: navUp
  });
  
  /* PRODUCT PAGES > FANCY SELECT 
  -----------------------------------------------------*/

  $('#product-select').fancySelect();

  // PAGE > COLLECTIONS > ALL
  $('#sidebar dt').click(function() {
    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
      $(this).parent().find('dd').slideUp();
    }
    else {
      $(this).addClass('open');
      $(this).parent().find('dd').slideDown();
    }
  });
  
  $('#mobileDropDown dt').click(function() {
    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
      $(this).parent().find('dd').slideUp();
    }
    else {
      $(this).addClass('open');
      $(this).parent().find('dd').slideDown();
    }
  });
  
  
  /* INITIALIZE BOOTSTRAP
  -----------------------------------------------------*/
  
  $('#productTabs a').click(function (e) {
    e.preventDefault()
    $(this).tab('show');
  });
  
   /* HOMEPAGE POP-UP
  -----------------------------------------------------*/
  /*
  function openFancybox() {
    setTimeout( function() {$('#popUpLink').trigger('click'); },7000);
  }
  
    var visited = $.cookie('visited');
    if (visited == 'yes') {
        return false;
    } else {
        openFancybox();
    }
    $.cookie('visited', 'yes', { expires: 7 });
  $('#popUpLink').fancybox();
  */

  /* FUNCTIONS
  -----------------------------------------------------*/

  //$(".rslides").responsiveSlides();
  
  function navDown() {
    var offset = $(this).offset().left;
    	offset = offset - wrap.offset().left;
    $(this).find('.subNav').css({
      'left': '-' + offset + 'px',
      'padding-left': offset + 'px'
    });
    $(this).find('.subNav').slideDown('fast');
    $(this).find('a').addClass('active');
  }

  function navUp() {
    $(this).find('.subNav').slideUp('fast');
    $(this).find('a').removeClass('active');
  }

  function openShoppingCart() {
    wrap.animate({'margin-left': '-320px'}, 150);
    shoppingBagSlider.animate({'right': '0px'}, 150);
    wrap.promise().done(function(){
      $('html,body').css('overflow', 'hidden');
      wrap.addClass('shoppingBagIsOpen');
    });
  }
  
  function closeShoppingCart() {
    wrap.animate({'margin-left': '0px'}, 150);
    shoppingBagSlider.animate({'right': '-320px'}, 150);
    wrap.promise().done(function(){
      $('html,body').css('overflow', 'auto');
        wrap.removeClass('shoppingBagIsOpen');
    });
  }
  
  function openSearchBox() {
    wrap.animate({'margin-left': '-320px'}, 150);
    searchBoxSlider.animate({'right': '0px'}, 150);
    wrap.promise().done(function(){
      $('html,body').css('overflow', 'hidden');
      wrap.addClass('searchBoxIsOpen');
    });
  }
  
  function closeSearchBox() {
    wrap.animate({'margin-left': '0px'}, 150);
    searchBoxSlider.animate({'right': '-320px'}, 150);
    wrap.promise().done(function(){
      $('html,body').css('overflow', 'auto');
        wrap.removeClass('searchBoxIsOpen');
    });
  }
  
  
  $('#carttab a').click(function (e) {
  e.preventDefault()
  $(this).tab('show')
})
});
$(document).ready(function() {

  $('#shopping-bag-slider .tab-content').css({'height':$(window).height()-50});
  $('#shopping-bag-slider .tab-content').css({'overflow':'auto'});
  
  $('#search-slider .tab-content').css({'height':$(window).height()-50});
  $('#search-slider .tab-content').css({'overflow':'auto'});
  

});
